export type FeatureFlagsFetchOptions = {
  /** When true, skip toggling loading state (background poll / refresh). */
  background?: boolean;
};

type RefetchFeatureFlagsImpl = ((options?: FeatureFlagsFetchOptions) => Promise<void>) | null;

let refetchFeatureFlagsImpl: RefetchFeatureFlagsImpl = null;

export const registerFeatureFlagsRefetch = (impl: RefetchFeatureFlagsImpl): void => {
  refetchFeatureFlagsImpl = impl;
};

/**
 * Refetches feature flags from disney-ad-manager-gql.
 * Registered by FeatureFlagsProvider while mounted.
 */
export const refetchFeatureFlags = async (options?: FeatureFlagsFetchOptions): Promise<void> => {
  if (!refetchFeatureFlagsImpl) {
    return;
  }

  await refetchFeatureFlagsImpl({
    background: options?.background ?? true,
  });
};
